import Marquee from "react-fast-marquee";
import { useLang } from "@/i18n";

export default function MarqueeSection() {
  const { t } = useLang();
  return (
    <section className="relative py-16 md:py-24 border-y border-[#d4af37]/15 bg-[#050505] overflow-hidden" data-testid="marquee-section">
      <Marquee speed={38} gradient={false} className="overflow-hidden">
        <div className="flex items-center">
          {Array.from({ length: 4 }).map((_, i) => (
            <span key={i} className="flex items-center">
              <span className="font-serif-lux text-6xl md:text-8xl lg:text-[9rem] leading-none tracking-tight text-stroke-gold px-8">
                {t.marquee}
              </span>
              <span className="text-[#d4af37] text-5xl px-4">&#10022;</span>
            </span>
          ))}
        </div>
      </Marquee>
    </section>
  );
}
